﻿import { opaccFilterCriterias } from './opacc.class.filter-criterias.factory.js';

export class SelectFilter {

  constructor(item, wrapper) {
    this.filterItem = item;
    this.wrapperItem = wrapper;
    this.id = this.filterItem.id;
    this.filterType = this.filterItem.dataset.opFiltertype;
  }

  selectValueByTargetAndSetFilterCriterias(elem) {
    let elementControl = elem.control || this.wrapperItem.querySelector(`#${elem.htmlFor}`);
    return this.selectValue(elementControl); // input      
  }

  selectValue(selectedItem) {
    switch (this.filterType) {
    case 'B':
      if (selectedItem.checked == true) {
        selectedItem.checked = false;
        opaccFilterCriterias.remove(selectedItem.dataset.opFilterattr, selectedItem.value);

      } else {
        selectedItem.checked = true;
        opaccFilterCriterias.add(selectedItem.dataset.opFilterattr, selectedItem.value);
      }
      break;
    default:
      selectedItem.checked = !selectedItem.checked;
      if (selectedItem.checked) {
        opaccFilterCriterias.change(selectedItem.dataset.opFilterattr, selectedItem.value);
      } else {
        opaccFilterCriterias.remove(selectedItem.dataset.opFilterattr);
      }
      break;
    }
  }

  searchValue(elem) {
    let listItems = elem.querySelector('.select-list').children;

    this.wrapperItem.addEventListener('keyup', e => {
      let searchString = e.target.value.toLowerCase();
      Array.from(listItems).forEach(i => {
        let item = i.querySelector('input');
        
        if (item.nextElementSibling.innerText.toLowerCase().indexOf(searchString) < 0) {
          i.style.display = 'none';
        } else {
          !item.checked ? i.style.display = 'block': i.style.display = 'inherit';
        }
      });
    });
  }
}